import { GraphQLError } from 'graphql';
import ERROR_8BASE_CODES from '@8base/error-codes';

export const GRAPHQL_ISSUE_CODE = ERROR_8BASE_CODES;

export interface GraphQLIssue extends GraphQLError {
  code?: keyof typeof GRAPHQL_ISSUE_CODE;
}
